import { createSlice } from '@reduxjs/toolkit';

export interface InstalledProductsState {
  locationId: string;
  locationName: string;
  turbineId: string;
  turbineType: string;
  turbineName: string;
}

const initialState: InstalledProductsState = {
  locationId: '',
  locationName: '',
  turbineId: '',
  turbineType: '',
  turbineName: ''
};

export const installedProductsSlice = createSlice({
  name: 'installedProducts',
  initialState,
  reducers: {
    saveLocationId: (state, action) => {
      state.locationId = action.payload.locationId;
    },
    saveLocationName: (state, action) => {
      state.locationName = action.payload.locationName;
    },
    saveTurbineId: (state, action) => {
      state.turbineId = action.payload.turbineId;
    },
    saveTurbineType: (state, action) => {
      state.turbineType = action.payload.turbineType;
    },
    saveTurbineName: (state, action) => {
      state.turbineName = action.payload.turbineName;
    },
    removeLocationId: state => {
      state.locationId = '';
    },
    removeLocationName: state => {
      state.locationName = '';
    },
    removeTurbineId: state => {
      state.turbineId = '';
    },
    removeTurbineType: state => {
      state.turbineType = '';
    },
    removeTurbineName: state => {
      state.turbineName = '';
    },
    clearInstalledProducts: () => initialState
  }
});

export const {
  saveLocationId,
  saveLocationName,
  saveTurbineId,
  saveTurbineType,
  saveTurbineName,
  removeLocationId,
  removeLocationName,
  removeTurbineId,
  removeTurbineType,
  removeTurbineName,
  clearInstalledProducts
} = installedProductsSlice.actions;

export default installedProductsSlice.reducer;
